// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ocvgfylcmtkulcqnlvin.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9jdmdmeWxjbXRrdWxjcW5sdmluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0NDUzMzMsImV4cCI6MjA3NDAyMTMzM30.fLGHknhV2UECvUQLInXUO8-y36AJYIbIjAUIHI0B3TQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});